import { Box, Loader, SectionHelper, Text } from '@wix/design-system';
import { CycleUtils, useFormatDate, usePageScrollLock } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { PlanFeaturesModalContent } from '../../../../components';
import { useIsNewPlanFeaturesModal } from '../../../../experiments';
import { SwitchProductModule } from '../../switch-product.module';
import styles from './PlanFeaturesModal.scss';
const H2_TITLE = {
  '--wds-font-size-heading-3': 'var(--wds-font-size-heading-2)',
  '--wds-font-weight-heading-3': 'var(--wds-font-weight-heading-2)',
  '--wds-font-line-height-heading-3': 'var(--wds-font-line-height-heading-2)',
  '--wds-font-letter-spacing-heading-3': 'var(--wds-font-letter-spacing-heading-2)'
};
export const PlanFeaturesModal = _ref => {
  var _currentProduct$prici;
  let {
    onClose,
    onShow
  } = _ref;
  const {
    t,
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const {
    locale
  } = SwitchProductModule.internals.useContext();
  const formatDate = useFormatDate({
    locale
  });
  usePageScrollLock();
  const platformContext = PremiumPurchasePlatformModule.internals.useContext();
  const {
    ready,
    isNewPlanFeaturesModal
  } = useIsNewPlanFeaturesModal();
  const {
    data: currentProductData
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const currentProduct = currentProductData == null ? void 0 : currentProductData.currentProduct;
  const cycleKey = `change_plan.current_plan_modal.${CycleUtils.convertToBillingPaymentCycle(currentProduct == null ? void 0 : currentProduct.cycle)}.billed`;
  const monthlyPrice = currentProduct == null || (_currentProduct$prici = currentProduct.pricing) == null || (_currentProduct$prici = _currentProduct$prici.monthlyTotal) == null ? void 0 : _currentProduct$prici.formattedAmount;
  const subtitleKey = monthlyPrice ? 'change_plan.current_plan_modal.payment_details_advanced' : 'change_plan.current_plan_modal.payment_details_advanced.new';
  const subtitle = t(subtitleKey, {
    planName: currentProduct == null ? void 0 : currentProduct.productName,
    price: monthlyPrice,
    cycle: t(cycleKey),
    endDate: formatDate((currentProduct == null ? void 0 : currentProduct.periodEndDate) ?? undefined)
  });
  const shouldShowPlanNotOfferedNote = !(currentProductData != null && currentProductData.isCurrentProductFamilyInOffering) && !(currentProductData != null && currentProductData.isCurrentProductInOffering);
  const planNotOfferedNote = /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "change_plan.current_plan_modal.explanation_advanced",
    values: {
      planName: currentProduct == null ? void 0 : currentProduct.productName
    },
    components: [/*#__PURE__*/React.createElement("strong", null)]
  });
  const sectionHelper = shouldShowPlanNotOfferedNote && !isNewPlanFeaturesModal ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "standard"
  }, planNotOfferedNote)) : undefined;
  const footnote = shouldShowPlanNotOfferedNote && isNewPlanFeaturesModal ? /*#__PURE__*/React.createElement(Box, {
    maxWidth: "590px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, planNotOfferedNote)) : undefined;
  const handleClose = () => {
    onClose == null || onClose();
    SwitchProductModule.SDK.modalsController.PlanFeaturesModal.hide();
  };
  React.useEffect(() => {
    onShow == null || onShow();
  }, [onShow]);
  if (!ready) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    context: {
      productTypeId: platformContext.productTypeId,
      purchaseContext: {}
    }
  }, /*#__PURE__*/React.createElement(PlanFeaturesModalContent, {
    productId: (currentProduct == null ? void 0 : currentProduct.productId) ?? '',
    title: t('Advanced.Plans_change.plan_modal.view_current_plan_title'),
    t: t,
    Trans: Trans,
    subtitle: subtitle,
    footnote: footnote,
    footer: sectionHelper,
    isDetailedView: isNewPlanFeaturesModal,
    className: isNewPlanFeaturesModal ? styles.harmony : undefined,
    style: isNewPlanFeaturesModal ? H2_TITLE : undefined,
    primaryButtonProps: isNewPlanFeaturesModal ? {
      skin: 'dark'
    } : undefined,
    maxHeight: "calc(100vh - 2 * var(--wds-space-800))",
    onClose: handleClose
  }));
};
//# sourceMappingURL=PlanFeaturesModal.js.map